// Init Swiper 1
const swiper = new Swiper(".video-carousel__swiper", {
   loop: true,
   navigation: {
      nextEl: ".custom-swiper-button-next",
      prevEl: ".custom-swiper-button-prev",
   },
   pagination: {
      clickable: true,
      el: ".custom-swiper-pagination",
   },
   breakpoints: {
      320: {
         slidesPerView: "auto",
         spaceBetween: 16,
         // centeredSlides: true,
      },
      480: {
         // slidesPerView: "auto",
         slidesPerView: 2,
         spaceBetween: 16,
         slidesPerGroup: 2,
         // slidesOffsetAfter: 64,
         // slidesOffsetBefore: 48,
      },
   },
});

// swiper.loopDestroy();

// Init Swiper 2

const swiper2 = new Swiper(".video-carousel__swiper-two", {
   // slidesPerView: 3,
   // spaceBetween: 16,
   // loop: true,
   loop: true,
   slidesPerView: 1,
   navigation: {
      nextEl: ".custom-swiper-button-next",
      prevEl: ".custom-swiper-button-prev",
   },
   pagination: {
      clickable: true,
      el: ".custom-swiper-pagination",
   },
   breakpoints: {
      768: {
         // slidesPerView: 1,
         centeredSlides: true,
         rewind: true,
      },
      1024: {
      },
      1200: {
      },
      1320: {
      },
   },
});

// swiper2.loopDestroy();